// Preset avatar color themes for the student profile. Keys must match
// User::AVATAR_COLORS on the backend.
export const AVATAR_COLOR_OPTIONS = [
  {
    key: 'slate',
    swatchClass: 'bg-gray-400 dark:bg-gray-500',
    gradientClass: 'bg-gradient-to-br from-gray-200 to-gray-300 dark:from-gray-600 dark:to-gray-700',
    textClass: 'text-gray-700 dark:text-gray-200',
  },
  {
    key: 'blue',
    swatchClass: 'bg-blue-400 dark:bg-blue-500',
    gradientClass: 'bg-gradient-to-br from-blue-200 to-blue-300 dark:from-blue-700 dark:to-blue-800',
    textClass: 'text-blue-900 dark:text-blue-100',
  },
  {
    key: 'green',
    swatchClass: 'bg-green-400 dark:bg-green-500',
    gradientClass: 'bg-gradient-to-br from-green-200 to-green-300 dark:from-green-700 dark:to-green-800',
    textClass: 'text-green-900 dark:text-green-100',
  },
  {
    key: 'purple',
    swatchClass: 'bg-purple-400 dark:bg-purple-500',
    gradientClass: 'bg-gradient-to-br from-purple-200 to-purple-300 dark:from-purple-700 dark:to-purple-800',
    textClass: 'text-purple-900 dark:text-purple-100',
  },
  {
    key: 'pink',
    swatchClass: 'bg-pink-400 dark:bg-pink-500',
    gradientClass: 'bg-gradient-to-br from-pink-200 to-pink-300 dark:from-pink-700 dark:to-pink-800',
    textClass: 'text-pink-900 dark:text-pink-100',
  },
  {
    key: 'amber',
    swatchClass: 'bg-amber-400 dark:bg-amber-500',
    gradientClass: 'bg-gradient-to-br from-amber-200 to-amber-300 dark:from-amber-700 dark:to-amber-800',
    textClass: 'text-amber-900 dark:text-amber-100',
  },
  {
    key: 'teal',
    swatchClass: 'bg-teal-400 dark:bg-teal-500',
    gradientClass: 'bg-gradient-to-br from-teal-200 to-teal-300 dark:from-teal-700 dark:to-teal-800',
    textClass: 'text-teal-900 dark:text-teal-100',
  },
  {
    key: 'rose',
    swatchClass: 'bg-rose-400 dark:bg-rose-500',
    gradientClass: 'bg-gradient-to-br from-rose-200 to-rose-300 dark:from-rose-700 dark:to-rose-800',
    textClass: 'text-rose-900 dark:text-rose-100',
  },
];

const DEFAULT_OPTION = AVATAR_COLOR_OPTIONS[0];

// The color a nil/unrecognized avatar_color renders (and should read) as.
// Exported so callers comparing against the "current" color (e.g. a swatch
// picker's selected state) apply the same fallback getAvatarColorClasses does.
export const DEFAULT_AVATAR_COLOR = DEFAULT_OPTION.key;

export function getAvatarColorClasses(key) {
  return AVATAR_COLOR_OPTIONS.find((option) => option.key === key) || DEFAULT_OPTION;
}
